export default __webpack_public_path__ + "d43dd364c4873a149ee93c3af910ae0a.png";